<template>
  <div class="p-l-5">
    <div class="m-b-2 m-t-5">
      <strong>{{ columnDisplayName }}</strong>
    </div>

    <table class="table_beauty condensed-alternate routing-plan-args">
      <thead>
        <tr class="bg-transparent">
          <th
            v-t="'PRIORITY'"
            class="text-right routing-plan-args__priority"
          />
          <th
            v-t="'WEIGHT'"
            class="text-right routing-plan-args__weight"
          />
          <th v-t="'NAME'" />
          <th
            v-t="'REASON'"
            v-if="columnName.toLowerCase() === 'ineligibletargets'"
          />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(target, index) in parsedCallPlanDetail"
          :key="index"
          class="bg-transparent"
        >
          <td class="text-right">
            {{ target.priority }}
          </td>

          <td class="text-right">
            {{ target.weight }}
          </td>

          <td>{{ target.name }}</td>

          <td v-if="columnName.toLowerCase() === 'ineligibletargets'">
            {{ target.ineligibilityReason }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
const splitRegex = /(\[\d+,\s?\d+\])/gm;
const splitTargetsRegex = /(\[\d+,\s?\d+\],)/gm;

import messages from './locales';

export default {
  name: 'RoutingPlanDetail',
  props: {
    targets: {
      type: String,
      default: '',
    },
    columnName: {
      type: String,
      default: '',
    },
    columnDisplayName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      parsedCallPlanDetail: [],
    };
  },
  watch: {
    targets: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.parsedCallPlanDetail = this.parseCallPlanDetail(
            this.getTargetsFromString(newValue)
          );
        }
      },
    },
  },
  methods: {
    getTargetsFromString(value) {
      let splited = value.split('\n');
      let targets = [];

      for (let j = 0; j < splited.length; j++) {
        if (splited[j]) {
          let splitString = splited[j].split(splitTargetsRegex);
          for (let i = 0; i < splitString.length; i += 2) {
            if (splitString[i]) {
              targets.push(`${splitString[i]}${splitString[i + 1] ? splitString[i + 1] : ''}`.replace(/,$/, ''));
            }
          }
        }
      }
      return targets;
    },
    parseCallPlanDetail(targets) {
      if (targets?.length) {
        return targets
          .map((target) => {
            target.replace('\n', '');
            let split = target.split(splitRegex);
            let priorityAndWeight = split[1].replace(/[\[\]]/g, '').split(',');

            return {
              name: split[0],
              priority: priorityAndWeight[0],
              weight: priorityAndWeight[1],
              ineligibilityReason: split[2] || '',
            };
          })
          .sort((targetA, targetB) => {
            var priorityComparison = targetA.priority - targetB.priority;

            if (priorityComparison == 0) {
              return targetA.weight - targetB.weight;
            }

            return priorityComparison;
          });
      }

      return [];
    },
  },
  i18n: {
    locale: 'en',
    messages
  }
};
</script>